

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { NewsModule } from '@/store/modules/news/news.store';
import { ModalConstants } from '@/core/constants';

import UrlService from '@/services/url/urlHelper.service';
import ServerStatus from '@/components/dashboard/metric/ServerStatus.vue';
import SimpleRealmOverlay from '@/components/dashboard/realms/SimpleRealmOverlay.vue';
import UserStatistics from '@/components/dashboard/users/UserStatistics.vue';
import NewsStatistcs from '@/components/dashboard/news/NewsStatistics.vue';

@Component({
    components: {
        ServerStatus,
        SimpleRealmOverlay,
        UserStatistics,
        NewsStatistcs
    }
})
export default class Home extends Vue {
	@Prop() isLoggedIn!: boolean;

	get Realms() {
	    return RealmsModule.realms;
	}

	get ActiveRealm() {
	    return RealmsModule.ActiveRealm;
	}

	created() {
	    if (!this.ActiveRealm && this.isLoggedIn) {
	        this.$bvModal.show(ModalConstants.SelectRealm);
	    }

	    NewsModule.GetNews();
	}

	mounted() {
	    if (UrlService.hasQueryParam('modals', ModalConstants.Login)) {
	        this.$bvModal.show(ModalConstants.Login);
	    }
	}
}
